import React, { Component, PropTypes } from 'react';
import { login, logout } from 'common/ducks/user';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { reduxForm, Form, Field } from 'redux-form';
import { withRouter, Link } from 'react-router';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';
import {
  DEFAULT_REQUIRED_MESSAGE, EMAIL_INVALID_MESSAGE, TextInputField, PasswordInputField,
} from 'common/components/form_fields';
import PwdResetRequest from 'login/containers/password_reset_request';

// Validation routines for the login form
const loginFormValidation = values => {
  const errors = {};

  if (!values.password) {
    errors.password = DEFAULT_REQUIRED_MESSAGE;
  }

  if (!values.identification) {
    errors.identification = DEFAULT_REQUIRED_MESSAGE;
  }

  return errors;
};

class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.state = { requestPwdReset: false };

    this.toggleRequestPwdResetModal = this.toggleRequestPwdResetModal.bind(this);
    this.login = this.login.bind(this);
    this.onLoginClick = this.onLoginClick.bind(this);
  }

  toggleRequestPwdResetModal(e) {
    e.preventDefault()
    this.setState({requestPwdReset: !this.state.requestPwdReset})
  }

  login(values) {
    const { login, next, onSuccess } = this.props;
    const promise = login(values.identification, values.password, next);
    return promise.then(onSuccess);
  }

  onLoginClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.submit();
  }

  render() {
    const { error, handleSubmit, submitting, hideOptions } = this.props;

    return (
      <div>
        <h3 className="show-for-small-only">Login</h3>

        <Form onSubmit={handleSubmit(this.login)} className={classnames({ error })} noValidate>
          <Field name="identification" component={TextInputField} label="Email address or username" />

          <Field name="password" component={PasswordInputField} label="Password" />

          {!hideOptions &&
          <div className="forgot-link">
            <button className="btn btn-sm btn-text" type="button" onClick={this.toggleRequestPwdResetModal}>
              Forgot password
            </button>
          </div>}

          <p className="global-error-msg">{ error }</p>

          <button disabled={submitting} onClick={this.onLoginClick}
              className="btn btn-block btn-tertiary login-button">
            Log in
          </button>

          {!hideOptions &&
          <p className="registration-link">
            Not yet a member? <Link rel="nofollow" to='/register/'>Create account.</Link>
          </p>}
        </Form>
        { this.state.requestPwdReset &&
        <PwdResetRequest onClose={this.toggleRequestPwdResetModal}/>}
      </div>)
  }
};

LoginForm = reduxForm({
  form: 'loginForm',
  validate: loginFormValidation,
})(LoginForm);

const mapStateToProps = (state, { next, location }) => {
  return {
    /* next URL can be passed as a prop explicitly or read from query params */
    next: next !== undefined? next : location.query.next,
  }
}

LoginForm = withRouter(connect(mapStateToProps, { login })(LoginForm));

const Login = ({ resuming, user }) => (
  <div id="content" className={classnames("l-content login", {
    "l-content-centered": !user.logged_in
  })}>
    <Meta
      title="Login"
      meta={[
        { name: "robots", content: "noindex,follow" },
      ]}
      link={[{ rel: "canonical", href: getCanonicalURL("/login/" ) }]}
    />
    { user.logged_in?
    <section className="login-contents">
      <div className="row align-center text-center">
        <div className="columns small-16 medium-12 large-6">
          <h3>You are already logged in.</h3>
          <p>Click on the button below to go to Your Projects.</p>
          <Link to='/your-projects/' className="btn btn-tertiary">Your Projects</Link>
        </div>
      </div>
    </section> :
    <div>
      { resuming &&
      <div className="callout warning resuming">
        <h4>You've been logged out. Log in again to resume your session. <br/></h4>
        If you recently created your account and need a password, please find the email we sent
        you to verify your email.<br/> Once you click the verification link in that email you'll be
        able to create a password to access crowdspring.<br/>
        If you didn't receive that email, click the "Forgot Password" link below to set a new
        password.
      </div> }
      <section className="login-contents">
        <div className="row align-center">
          <div className="columns small-16 medium-12 large-6 login-form-wrapper">
            <LoginForm />
          </div>
        </div>
      </section>
    </div> }
  </div>
);

class Logout extends Component {
  componentDidMount() {
    this.props.logout();
  }

  render() {
    return (
      <div className="l-content logout" id="content">
        <section className="account">
          <div className="columns small-12">
            <p>You have been logged out.</p>
          </div>
        </section>
      </div>
    );
  }
}

Logout.propTypes = {
  logout: PropTypes.func,
};

const LogoutWrapped = connect(() => ({}), { logout })(Logout);

const LoginWrapped = connect(({ user }, { location }) => ({
  resuming: location.query.resuming === "true",
  user
}))(Login);

LoginForm = withRouter(connect(mapStateToProps, { login })(LoginForm));

export { LoginForm, LoginWrapped as Login, LogoutWrapped as Logout };



// WEBPACK FOOTER //
// ./login/containers/index.jsx